import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import makeStyles from '@material-ui/core/styles/makeStyles';
import React, { memo, useCallback } from 'react';

interface IProps {
  opened: boolean;
  submitDisabled: boolean;
  children: React.ReactNode;
  title?: string;
  message?: string;
  showOk?: boolean;
  customOkButton?: React.ReactNode;
  buttonOk?: string;
  buttonCancel?: string;
  onClose: () => void;
  onSubmit?: () => void;
}

const useStyle = makeStyles({
  root: {
    zIndex: 1600,
    padding: '16px 24px',
  },
  content: {
    minWidth: 400,
    textAlign: 'center',
  },
});

const MyModal = memo(({ showOk = true, ...props }: IProps) => {
  const classes = useStyle(props);

  const handleOk = useCallback(() => props.onSubmit(), [props]);
  const handleCancel = useCallback(() => props.onClose(), [props]);

  if (!props.opened) {
    return null;
  }

  return (
    <Dialog open={props.opened} keepMounted TransitionComponent={Transition} onClose={handleCancel} className={classes.root} maxWidth='sm' fullWidth>
      <DialogTitle>{props.title}</DialogTitle>
      <DialogContent>
        {props.message && <DialogContentText className={classes.content}>{props.message}</DialogContentText>}
        {props.children}
      </DialogContent>
      <DialogActions className={classes.root}>
        <Button onClick={handleCancel} variant='outlined'>
          {props.buttonCancel ?? 'Cancelar'}
        </Button>
        {showOk && (
          <Button onClick={handleOk} disabled={props.submitDisabled} color='primary' variant='contained' type='submit'>
            {props.buttonOk ?? 'Prosseguir'}
          </Button>
        )}
        {props?.customOkButton && props.customOkButton}
      </DialogActions>
    </Dialog>
  );
});

function Transition(props: any) {
  return <Slide direction='up' {...props} />;
}

export default MyModal;
